import * as React from "react";
const SvgFiBrandsCreativeCommonsZero = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-creative-commons-zero_svg__a)">
      <path d="M12.5 5.093C8.373 5.093 7.335 8.83 7.335 12s1.038 6.907 5.165 6.907 5.165-3.738 5.165-6.907-1.038-6.907-5.165-6.907M10.277 12c0-1.396.101-4.303 2.223-4.303.168 0 .32.025.464.059.296.246.442.585.157 1.059l-2.75 4.849A12.5 12.5 0 0 1 10.278 12m2.223 4.303c-.168 0-.32-.017-.465-.051a5 5 0 0 1-.21-.067c-.473-.193-.77-.542-.342-1.16l3.072-5.092c.146.744.167 1.52.167 2.067.001 1.396-.1 4.303-2.222 4.303" />
      <path d="M24.09 7.386a11.5 11.5 0 0 0-2.68-3.874C18.955 1.17 15.97 0 12.474 0c-3.468 0-6.39 1.159-8.77 3.487a12.2 12.2 0 0 0-2.768 3.95A11.5 11.5 0 0 0 0 12q0 2.4.936 4.563.937 2.164 2.722 3.899a13 13 0 0 0 4.062 2.639q2.277.9 4.754.899c1.652 0 3.258-.31 4.806-.924a12.9 12.9 0 0 0 4.15-2.655c1.175-1.1 2.065-2.361 2.66-3.79q.912-2.165.91-4.631c0-1.629-.301-3.17-.91-4.614m-4.272 11.488a10.8 10.8 0 0 1-3.415 2.168c-1.25.5-2.538.748-3.878.748q-2.032-.001-3.886-.731a10.6 10.6 0 0 1-3.326-2.143 10.2 10.2 0 0 1-2.277-3.193A9.25 9.25 0 0 1 2.25 12c0-1.3.267-2.545.787-3.731a10.4 10.4 0 0 1 2.277-3.235q2.926-2.873 7.213-2.874c2.827 0 5.239.962 7.248 2.891a9.6 9.6 0 0 1 2.214 3.177A9.5 9.5 0 0 1 22.75 12c0 2.757-.982 5.045-2.932 6.874" />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-zero_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsZero;
